import * as React from 'react';
import Wrapper from './Wrapper';

const StatusClose = Wrapper(props => (
  <svg
    aria-hidden="true"
    focusable="false"
    height={props.size || 20}
    width={props.size || 20}
    stroke={props.stroke || '#E71D32'}
    fill="none"
    viewBox="0 0 24 24"
    strokeWidth={2}
    {...props}
  >
    <path
      clipRule="evenodd"
      d="M12 23.249c6.213 0 11.25-5.037 11.25-11.25S18.213.749 12 .749.75 5.786.75 11.999 5.787 23.249 12 23.249z"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M7.5 16.499l9-9M16.5 16.499l-9-9"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
));

export default StatusClose;
